import React, { Fragment } from "react";
import { GetHandleProps } from "react-compound-slider";
import "./MtiSliderHandle.css";

// *******************************************************
// HANDLE COMPONENT
// *******************************************************

type Props = {
  domain: [number, number];
  handle: { id: string; value: number; percent: number };
  disabled?: boolean;
  getHandleProps: GetHandleProps;
};

export function MtiSliderHandle({
  domain: [min, max],
  handle: { id, value, percent },
  disabled = false,
  getHandleProps,
}: Props) {
  return (
    <Fragment>
      <div
        className="mti-slider-handle-container"
        style={{
          left: `${percent}%`,
        }}
        {...getHandleProps(id)}
      />
      <div
        role="slider"
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={value}
        className="mti-slider-handle-slider"
        style={{
          left: `${percent}%`,
          backgroundColor: disabled ? "#C0C0C0" : "#FFFFFF",
          borderColor: disabled ? "#838383" : "#E38006",
        }}
      />
    </Fragment>
  );
}
